module.exports = __webpack_public_path__ + "img/Weapon_53.3c99a33f.png";